import React from "react";

import clsx from "clsx";
import { DefaultToast, type ToastProps } from "react-toast-notifications";

const toastStates = {
  entering: { transform: "translate3d(0, 200%, 0)", opacity: 0 },
  entered: { transform: "translate3d(0,0,0)", opacity: 1 },
  exiting: { transform: "scale(0.66)", opacity: 0 },
  exited: { transform: "scale(0.66)", opacity: 0 },
};

export const Toast = ({
  children,
  appearance,
  transitionDuration,
  ...props
}: ToastProps & { blockDismiss?: boolean }) => {
  const info = appearance === "info";
  const warning = appearance === "warning";

  if (info || warning) {
    const blockDismiss = props.blockDismiss ?? false;

    return (
      <div
        className="flex m-3 text-sm min-w-[400px] rounded-lg shadow-[0_3px_8px_0_rgba(0,0,0,0.175)]"
        style={{
          transition: `transform ${transitionDuration}ms cubic-bezier(0.2, 0, 0, 1), opacity ${transitionDuration}ms`,
          ...toastStates[props.transitionState],
        }}
      >
        <div
          className={clsx(
            "rounded-s-lg flex items-center justify-center w-10",
            {
              "bg-[#36B7B7]": info,
              "bg-[#F8BC24]": warning,
            },
          )}
        >
          <i
            className={clsx("fa-regular fa-sharp text-base text-white", {
              "fa-info-circle": info,
              "fa-triangle-exclamation": warning,
            })}
          />
        </div>
        <div
          className={clsx("flex-1 p-3 border-t border-[#eee]", {
            "bg-[#EDFBFB]": info,
            "bg-[#FFF4D3] text-[#996800]": warning,
          })}
        >
          {children}
        </div>
        <div
          className={clsx(
            "flex items-center justify-center rounded-e-lg w-10 border-t border-[#eee]",
            {
              "bg-[#EDFBFB]": info,
              "bg-[#FFF4D3]": warning,
            },
          )}
        >
          {!blockDismiss && (
            <button
              className="cursor-pointer"
              onClick={() => props.onDismiss()}
            >
              <i
                className={clsx("fa-regular fa-sharp fa-xmark text-base", {
                  "text-[#2a8d8d] hover:text-[#1f6868]": info,
                  "text-[#996800] hover:text-[#6f500e]": warning,
                })}
              ></i>
            </button>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <DefaultToast
        appearance={appearance}
        transitionDuration={transitionDuration}
        {...props}
      >
        {children}
      </DefaultToast>
    );
  }
};
